import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadCrumb from "src/Components/GlobalComponents/BreadCrumb";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import OrderAddProduct from "src/Components/PharmacyComponents/OrderPlacement/OrderAddProduct";
import OrderAddressDetails from "src/Components/PharmacyComponents/OrderPlacement/OrderAddressDetails";
import OrderPersonalDetails from "src/Components/PharmacyComponents/OrderPlacement/OrderPersonalDetails";
import httpRequest from "src/helpers/httpRequest";
import { IPharmaInventory, IqueryParams } from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import QueryString from "qs";
import OrderOverview from "src/Components/PharmacyComponents/OrderPlacement/OrderOverview";
import {
  countryRegex,
  flatVillaNoRegex,
  streetAddressRegex,
  buildingNameRegex,
  landmarkRegex,
  nameRegex,
  phoneNumberRegex,
  emailRegex,
} from "src/lib/constans";

interface IResponce {
  documents: IPharmaInventory[];
  paginated: IPaginated;
}

const PlaceOrder = () => {
  const tabs = [
    "Address Details",
    "Personal Details",
    "Add Products",
    "Overview",
  ];
  const [payload, setPayload] = useState<any>({
    address: "",
    emirate: "",
    city: "",
    streetAddress: "",
    flatVillaNo: "",
    buildingName: "",
    additionalInfo: "",
    country: "",
    mobileNumber: "",
    firstName: "",
    products: [],
    userDetails: {
      _id: "",
      email: "",
      gender: "",
      name: "",
    },
  });
  const [userSuggestions, setUserSuggestions] = useState<any[]>([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeTab, setActiveTab] = useState<string>("Address Details");
  const [allPharmaProducts, setAllPharmaProducts] = useState<
    IPharmaInventory[]
  >([]);
  const [validTabs, setValidTabs] = useState<{ [key: string]: boolean }>({
    "Address Details": true,
    "Personal Details": false,
    "Add Products": false,
    Overview: false,
  });
  const [errors, setErrors] = useState<{
    [key: string]: string;
  }>({
    address: "",
    emirate: "",
    city: "",
    streetAddress: "",
    flatVillaNo: "",
    buildingName: "",
    additionalInfo: "",
  });

  useEffect(() => {
    let chcekAll =
      validateAddressDetailsForm(true) &&
      validatePersonalDetailsForm(true) &&
      checkProducts(true);
    setValidTabs({
      "Address Details": true,
      "Personal Details": validateAddressDetailsForm(true),
      "Add Products": validatePersonalDetailsForm(true),
      Overview: chcekAll,
    });
  }, [payload]);

  const validateAddressDetailsForm = (onlyLength: boolean = false) => {
    const newErrors: { [key: string]: string } = {};

    if (!payload.address) {
      newErrors.address = "Address type is required";
    }

    if (!payload.emirate) {
      newErrors.emirate = "Province is required";
    }

    if (!payload.city) {
      newErrors.city = "City is required";
    }

    if (!payload.streetAddress) {
      newErrors.streetAddress = "Street address is required";
    } else if (!streetAddressRegex.test(payload.streetAddress)) {
      newErrors.streetAddress =
        "Street address should contain only letters, numbers, spaces, commas, periods, dashes, and slashes (10-100 characters)";
    }

    if (!payload.country) {
      newErrors.country = "Country is required";
    } else if (!countryRegex.test(payload.country)) {
      newErrors.country = "Please enter a valid country";
    }

    if (!payload.flatVillaNo) {
      newErrors.flatVillaNo = "House number is required";
    } else if (!flatVillaNoRegex.test(payload.flatVillaNo)) {
      newErrors.flatVillaNo =
        "House number should contain only letters, numbers, spaces, dashes, commas, and slashes (max 20 characters)";
    }

    if (!payload.buildingName) {
      newErrors.buildingName = "Building name is required";
    } else if (!buildingNameRegex.test(payload.buildingName)) {
      newErrors.buildingName =
        "Building name should contain only letters, numbers, spaces, commas, and dashes (max 50 characters)";
    }

    // Validate additional info if provided (optional field)
    if (payload.additionalInfo && !landmarkRegex.test(payload.additionalInfo)) {
      newErrors.additionalInfo =
        "Additional information should contain only letters, numbers, spaces, commas, dashes, and slashes (max 100 characters)";
    }

    if (onlyLength) {
      return Object.keys(newErrors).length === 0;
    } else {
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }
  };

  const validatePersonalDetailsForm = (onlyLength: boolean = false) => {
    const newErrors: { [key: string]: string } = {};
    if (!payload.userDetails.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(payload.userDetails?.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!payload.firstName) {
      newErrors.firstName = "Name is required";
    } else if (!nameRegex.test(payload.firstName)) {
      newErrors.firstName =
        "Name should contain only letters, spaces, and dashes (max 30 characters)";
    }
    if (!payload.mobileNumber) {
      newErrors.mobileNumber = "Mobile number is required";
    } else if (!phoneNumberRegex.test(payload.mobileNumber)) {
      newErrors.mobileNumber = "Please enter a valid mobile number";
    }
    if (onlyLength) {
      return Object.keys(newErrors).length === 0;
    } else {
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }
  };

  const checkProducts = (onlyLength: boolean = false) => {
    if (payload.products.length === 0) {
      if (onlyLength) {
        return false;
      } else {
        toast("Please add products to the cart", { type: "error" });
        setActiveTab("Add Products");
        return false;
      }
    }
    return true;
  };

  const [allProducts, setAllProducts] = useState<IPharmaInventory[]>([]);
  const [productLoader, setProductLoader] = useState(false);
  const [productQuantity, setProductQuantity] = useState<{
    [key: string]: number;
  }>({});

  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });

  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    searchProduct: "",
    bool: false,
    searchBrand: "", // depend on backend
    searchCategory: "", // depend on backend
  });

  const fetchUserSuggestions = async (value: string) => {
    setLoadingSuggestions(true);
    const { res, err } = await httpRequest<any>({
      path: `/customer?page=1&limit=5&search=${value}`,
    });
    if (res) {
      setUserSuggestions(res.documents);
    } else {
      toast(err, { type: "error" });
    }
    setLoadingSuggestions(false);
  };

  const handleChangeText = (txt: string) => {
    setQueryParams((prev) => ({
      ...prev,
      page: 1,
      searchProduct: txt,
    }));
  };

  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  const fetchAllProducts = async () => {
    if (productLoader) return;
    setProductLoader(true);
    const { bool, ...remainingParams } = queryParams;
    const { res, err } = await httpRequest<IResponce>({
      path: `/pharma-inventory/getAll?${QueryString.stringify(
        remainingParams
      )}`,
    });
    if (res) {
      const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } =
        res;
      setAllProducts(documents);
      let previousProduct = allPharmaProducts.filter(
        (product: IPharmaInventory) =>
          !documents.some((doc: IPharmaInventory) => doc._id === product._id)
      );
      setAllPharmaProducts([...previousProduct, ...documents]);
      setProductQuantity((prev: { [key: string]: number }) => ({
        ...prev,
        ...documents.reduce((acc: any, curr: any) => {
          // Agar product pehle se exist karta hai, to uski quantity maintain karo
          if (prev[curr._id] === undefined) {
            acc[curr._id] = 1;
          }
          return acc;
        }, {}),
      }));
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setProductLoader(false);
  };

  useEffect(() => {
    if(activeTab === "Add Products") {
      fetchAllProducts();
    }
  }, [activeTab , queryParams.page]);

  const navigate = useNavigate();

  return (
    <>
      <BreadCrumb
        current="Place Order"
        previous="dashboard"
        navigateUrl="/admin"
        isUpsert={true}
        btnShow={true}
        onPress={() => navigate("/admin/pharmacy/all-orders")}
      />
      <div className="table-container">
        <div className="flex gap-2 mb-5 items-center border-b border-gray-300 pb-5">
          {tabs.map((tab) => (
            <PrimaryBtn
              onClick={() => setActiveTab(tab)}
              ButtonText={tab}
              disabled={!validTabs[tab as keyof typeof validTabs]}
              disabledOpactiy={true}
              btnExtraStyle={{
                border: "1px solid",
                backgroundColor: activeTab === tab ? "#00443f" : "transparent",
                color: activeTab === tab ? "white" : "#00443f",
                borderColor: activeTab === tab ? "transparent" : "#00443f",
                padding: "0.5rem 2rem",
              }}
            />
          ))}
        </div>
        {activeTab === "Address Details" && (
          <OrderAddressDetails
            payload={payload}
            setPayload={setPayload}
            setActiveTab={setActiveTab}
            errors={errors}
            validateAddressDetailsForm={validateAddressDetailsForm}
            setErrors={setErrors}
          />
        )}
        {activeTab === "Personal Details" && (
          <OrderPersonalDetails
            payload={payload}
            setPayload={setPayload}
            setActiveTab={setActiveTab}
            userSuggestions={userSuggestions}
            fetchUserSuggestions={fetchUserSuggestions}
            showSuggestions={showSuggestions}
            setShowSuggestions={setShowSuggestions}
            loadingSuggestions={loadingSuggestions}
            errors={errors}
            setErrors={setErrors}
            validatePersonalDetailsForm={validatePersonalDetailsForm}
          />
        )}
        {activeTab === "Add Products" && (
          <OrderAddProduct
            payload={payload}
            setPayload={setPayload}
            setActiveTab={setActiveTab}
            allProducts={allProducts}
            productQuantity={productQuantity}
            paginated={paginated}
            queryParams={queryParams}
            setQueryParams={setQueryParams}
            handleChangeText={handleChangeText}
            handlePageChange={handlePageChange}
            productLoader={productLoader}
            setProductQuantity={setProductQuantity}
            allPharmaProducts={allPharmaProducts}
            checkProducts={checkProducts}
          />
        )}
        {activeTab === "Overview" && (
          <OrderOverview
            payload={payload}
            setActiveTab={setActiveTab}
            allProducts={allProducts}
            allPharmaProducts={allPharmaProducts}
            productQuantity={productQuantity}
            errors={errors}
            validateAddressDetailsForm={validateAddressDetailsForm}
            validatePersonalDetailsForm={validatePersonalDetailsForm}
          />
        )}
      </div>
    </>
  );
};

export default PlaceOrder;
